import { ComponentProps, useId } from 'react';
import { RadioGroup as AriaRadioGroup } from 'react-aria-components';

import { cardStyles, Typography } from '../../ui';
import { Radio, RadioProps } from '../radio/radio';
import { twMerge } from 'tailwind-merge';
import { CardStylesVariants } from '../../patterns/card';

type Props = {
  title?: string;
  items: Array<RadioProps>;
  variant: CardStylesVariants['variant'];
} & Omit<ComponentProps<typeof AriaRadioGroup>, 'children' | 'className'>;

export function RadioList(props: Props) {
  const { title, items, variant, ...rest } = props;
  const id = useId();

  return (
    <div className="flex flex-col gap-y-16">
      {title && (
        <Typography variant="body-l" weight="medium">
          {title}
        </Typography>
      )}

      <AriaRadioGroup
        className={twMerge('space-y-24 p-20', cardStyles({ variant }))}
        {...rest}
      >
        {items.map((item, index) => (
          <Radio key={`radio-list-${id}-item-${index}`} {...item} />
        ))}
      </AriaRadioGroup>
    </div>
  );
}
